export class StateToken {
  urlToken: string
  compIdentifier: string
  token: string

  // /**
  //  *
  //  */
  // constructor() {
  //     super();

  // }

  // static generateFullToken = (urlToken: string, compToken?: string): string =>
  //     `${urlToken}${(!!compToken ? '_' : '')}${compToken}`

  // static generateTokenObs =  (urlToken: string, compToken?: string): StateToken => ({
  //     urlToken: urlToken,
  //     compIdentifier: compToken,
  //     token: StateToken.generateFullToken(urlToken, compToken)
  // } as StateToken)

  static generateFullToken(urlToken: string, compToken?: string): string {
    return `${urlToken}${!!compToken ? '_' : ''}${compToken}`
  }

  static generateTokenObs(urlToken: string, compToken?: string): StateToken {
    return {
      urlToken: urlToken,
      compIdentifier: compToken,
      token: StateToken.generateFullToken(urlToken, compToken)
    } as StateToken
  }
}
